import { render, staticRenderFns } from "./FeaturedMemberCreator.vue?vue&type=template&id=381e04aa&"
import script from "./FeaturedMemberCreator.vue?vue&type=script&lang=js&"
export * from "./FeaturedMemberCreator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports